var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { rgba } from "polished";
import { Link } from "react-router-dom";
import { COLOR, BREAKPOINT } from "../../theme/constants";
export var BreadcrumbsWprapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 0.8125rem;\n  line-height: 1.25rem;\n"], ["\n  font-size: 0.8125rem;\n  line-height: 1.25rem;\n"])));
export var BreadcrumbsTitle = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: none;\n\n  ", "\n\n  @media ", " {\n    ", "\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  text-decoration: none;\n\n  ", "\n\n  @media ", " {\n    ", "\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_a) {
  var isLast = _a.isLast;
  return isLast ? "\n      color: " + COLOR.black + ";\n      pointer-events: none;\n      cursor: default;\n      " : "color: " + rgba(COLOR.black, 0.5) + ";";
}, BREAKPOINT.md, function (_a) {
  var isLast = _a.isLast,
      isLight = _a.isLight;
  return isLast ? "\n      color: " + (isLight ? COLOR.white : COLOR.black) + ";\n      pointer-events: none;\n      cursor: default;\n      " : "color: " + rgba(COLOR.black, 0.5) + ";";
}, COLOR.black);
export var BreadcrumbsDivider = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n\n  &::after {\n    content: \"-\";\n    font-weight: 700;\n    color: ", ";\n    display: inline-block;\n    margin: 0 0.25rem;\n  }\n"], ["\n  ", ";\n\n  &::after {\n    content: \"-\";\n    font-weight: 700;\n    color: ", ";\n    display: inline-block;\n    margin: 0 0.25rem;\n  }\n"])), function (_a) {
  var isLast = _a.isLast;
  return isLast && "display: none;";
}, rgba(COLOR.black, 0.5));
var templateObject_1, templateObject_2, templateObject_3;